import * as React from 'react';
import styled from 'styled-components';
import { NHLAPI } from '../modules/NHLAPI';
class DraftColumnPlayerIcon extends React.Component {
    constructor() {
        super(...arguments);
        this.nhl = new NHLAPI();
    }
    render() {
        return (React.createElement(Container, { imageURL: this.nhl.playerProfileImageSmall(this.props.player.id) }));
    }
}
export default DraftColumnPlayerIcon;
const Container = styled.div `
  background-color: rgba(0,0,0,1);
  background-image: url(${props => props.imageURL});
  background-size: contain;
  border-right: 2px solid #000;
  display: inline-block;
  height: 40px;
  vertical-align: middle;
  width: 40px;
`;
//# sourceMappingURL=DraftColumnPlayerIcon.js.map


// WEBPACK FOOTER //
// ./src/components/DraftColumnPlayerIcon.js